<template>
  <div>
    <VueApexCharts
      :key="chartkey"
      type="area"
      height="350"
      :options="chartOptions"
      :series="series"
    ></VueApexCharts>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
export default {
  props: ['data'],
  components: {
    VueApexCharts
  },
  data() {
    return {
      chartkey: 0,
      series: [
        {
          name: 'Ticket',
          data: []
        }
      ],
      chartOptions: {
        colors: ['#FF706B'],

        chart: {
          height: 350,
          type: 'area'
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth'
        },
        xaxis: {
          type: 'datetime',
          categories: []
        },
        tooltip: {
          x: {
            format: 'dd/MM/yy HH:mm'
          }
        }
      }
    }
  },
  mounted() {
    if (this.data) {
      var series = this.data.map((el) => {
        return { x: el.timestamp, y: parseFloat(el.total) }
      })
      this.series[0].data = series
      this.chartkey++
    }
  },
  computed: {}
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/ticket2/agentmanagement/OverviewTicketChart.vue